import { Action } from '../../utils/action.model';

export enum AuthActionTypes{
    loading = '[Auth] loading response',
    error = '[Auth] error response',
}

export class LoadingAuth implements Action {
    readonly type = AuthActionTypes.loading;
    constructor(public payload: { loading: boolean, recurso: string, message: string, messages: [] }) { };
}

export class ErrorAuth implements Action {
    readonly type = AuthActionTypes.error;
    constructor(public payload: { hasError: boolean, recurso: string, messageError: string, errors: [] }) { }
}

export type Auth = LoadingAuth | ErrorAuth 